module.exports = __webpack_public_path__ + "static/media/ChemistryIcon.82826836.svg";